import camelcase from 'camelcase'

const occupationType = {
  isOrder: {
    label: 'Заказ',
    value: 'is_order',
  },
  break: {
    label: 'Машина занята',
    value: 'break',
  },
  broken: {
    label: 'Поломка / ТО',
    value: 'broken',
  },
}

const getOccupationType = (type) => {
  if (!occupationType[camelcase(type)]) return occupationType.isOrder

  return occupationType[camelcase(type)]
}

export { occupationType, getOccupationType }
